import EditDiffusionContainer from './EditDiffusionContainer';

export default EditDiffusionContainer;